<p-blockUI [blocked]="visible">
  <div
    class="flex flex-column align-items-center notification-overlay-container bg-white text-center p-7"
    data-cy="notification-overlay"
    [appAutoFocus]="visible"
  >
    <div *ngIf="type === 'error'" class="flex flex-column align-items-center">
      <div class="error-icon-container flex align-items-center justify-content-center mb-5">
        <i class="mi-round mi-error-outline error-icon"></i>
      </div>
      <h1 class="mt-0 mb-5 text-error-base">{{ title }}</h1>
    </div>

    <div *ngIf="type === 'success'" class="flex flex-column align-items-center">
      <div class="success-icon-container flex align-items-center justify-content-center mb-5">
        <i class="mi-round mi-task-alt success-icon"></i>
      </div>
      <h1 class="mt-0 mb-5 text-success-base">{{ title }}</h1>
    </div>

    <p class="p2 mt-0 mb-4 notification-message">
      {{ message }}
    </p>
    <p *ngIf="additionalDetails" class="p3 mt-0 mb-4 text-black-400">
      {{ additionalDetails }}
    </p>
    <p class="p2 mt-0 mb-6 notification-message-contact">
      Contact us at <a href="tel:{{ ccsConfig.helpPhone }}">{{ ccsConfig.helpPhone }}</a> if you need additional
      support.
    </p>

    <button
      pButton
      type="button"
      label="OK"
      class="w-12rem"
      (click)="onConfirm()"
      data-cy="close-notification-overlay-button"
    ></button>
  </div>
</p-blockUI>
